<template>
  <div class="cooperation">
    <div class="container">
      <div class="organ">
        <el-link icon="el-icon-office-building" :underline="false">服务品牌</el-link>
        <!-- <p>Cooperative Partner</p> -->
        <p class="notes">我们始终站在客户的立场以崭新的创意和灵活的构思为客户提供专业优质的服务</p>
        <div class="demo-image">
          <div class="block" >
            <el-row>
              <el-col style="height:100px;display: flex;align-items: center;justify-content: center;" :span="6" v-for="(item,index) in data" :key="index"><el-image style="width: 120px;" :src="$http+item.file" :fit="fill"></el-image></el-col>
            </el-row>
          </div>
          <div style="clear: both;"></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        names: ['chery', 'lexus', 'faw', 'fawtoyota'],
        fill: "fill",
        data: []
      }
    },
    mounted() {
      this.getServer();
    },
    methods: {
      getServer: function() {
        this.axios.get(this.$http + "/api/index/getServerLogo", {
            params: {}
          })
          .then((res) => {
            console.log(res)
            this.data = res.data.data;
          })
          .catch((err) => {})
      }
    }
  }
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/Cooperation.vue